import { Box, type BoxProps } from '@mui/material';
import { forwardRef } from 'react';

export interface ImageProps extends Pick<BoxProps, 'sx'> {
  src: string;
  alt: string;
}

export const Image = forwardRef<HTMLImageElement, ImageProps>((props, ref) => (
  <Box component="img" {...props} ref={ref} />
));
